import { couponsRepository } from '~/api/repository/coupons';
import type { CART_TYPE } from '~/hooks/useCartTypeParam';

export const COUPONS_QUERY_KEY = {
  all: ['coupons'] as const,

  // 사용자 쿠폰 목록
  buyerCoupons: (params?: Record<string, unknown>) => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'buyer', params] as const,
    queryFn: () => couponsRepository.getBuyerCoupons(params),
  }),

  // 사용자 쿠폰 개수
  buyerCouponCount: () => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'buyer', 'count'] as const,
    queryFn: () => couponsRepository.getBuyerCouponCount(),
  }),

  // 특정 쿠폰 상세
  buyerCouponDetail: (buyerCouponId: number) => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'buyer', buyerCouponId] as const,
    queryFn: () => couponsRepository.getBuyerCouponDetail(buyerCouponId),
  }),

  // 체크아웃 쿠폰
  checkoutCoupons: (cartType: CART_TYPE) => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'checkout', cartType] as const,
    queryFn: () => couponsRepository.getCheckoutCoupons(cartType),
  }),

  // 다운로드된 쿠폰
  downloadedCoupons: (couponIds: number[]) => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'downloaded', couponIds] as const,
    queryFn: () => couponsRepository.getDownloadedCoupons(couponIds),
  }),

  // 포인트 쿠폰 목록
  pointCoupons: () => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'point'] as const,
    queryFn: () => couponsRepository.getPointCouponList(),
  }),

  // 쿠폰 상세
  detail: (couponId: number) => ({
    queryKey: [...COUPONS_QUERY_KEY.all, 'detail', couponId] as const,
    queryFn: () => couponsRepository.getCouponDetail(couponId),
  }),
};

// Mutation Keys (캐시 무효화에 사용)
export const COUPONS_MUTATION_KEY = {
  downloadAll: () => [...COUPONS_QUERY_KEY.all, 'download', 'all'] as const,
  download: (couponId: number) =>
    [...COUPONS_QUERY_KEY.all, 'download', couponId] as const,
  issuePoint: (couponId: number) =>
    [...COUPONS_QUERY_KEY.all, 'issue', 'point', couponId] as const,
};
